<ng-container *transloco="let t;">

  <div class="p-mb-4">
    <p-card>
      <h2>{{ t('common.labels.jobinformation') }}</h2>

      <div class="p-grid">
        <div class="p-col-12">
          <app-form-control [cid]="'hasjob'" [control]="form.get('jobinformation.hasjob')" [type]="'checkbox'" [label]="t('orderform.checkbox_hasjob')" [noMargin]="true" [edit]="inEdit" [basevalue]="!!order?.misc?.order?.jobtitle"></app-form-control>
        </div>
        <div class="p-col-4">
          <app-form-control [cid]="'jobtitle'" [control]="form.get('jobinformation.jobtitle')" [type]="'input'" [label]="t('common.labels.jobtitle')" [edit]="inEdit" [basevalue]="order?.misc?.order?.jobtitle || naValue"></app-form-control>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-4">
          <app-form-control [cid]="'recruiter'" [control]="form.get('jobinformation.recruiter')" [type]="'input'" [label]="t('common.labels.recruiter')" [edit]="inEdit" [basevalue]="order?.misc?.order?.recruiter"></app-form-control>
        </div>
        <div class="p-col-4">
          <app-form-control [cid]="'businessunit'" [control]="form.get('jobinformation.businessunit')" [type]="'group'" [filterBy]="'value.name'" [options]="options?.businessunits" [label]="t('common.labels.businessunit')" [edit]="inEdit" [basevalue]="getBusinessValueName()"></app-form-control>
        </div>
      </div>
    </p-card>
  </div>

</ng-container>
